function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-console */

/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import pickBy from 'lodash/pickBy';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import withAdControl from './with-ad-control';
import * as customPropType from './custom-prop-type';
import * as styles from '../style/adspot'; // Global store for tracking which ids were loaded on the page

import { jsx as ___EmotionJSX } from "@emotion/core";
var adsLoaded = {};
var loggedWarnings = {};

var AdSpot = /*#__PURE__*/function (_React$Component) {
  _inherits(AdSpot, _React$Component);

  var _super = _createSuper(AdSpot);

  function AdSpot(props) {
    var _this;

    _classCallCheck(this, AdSpot);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      renderServerSideFallback: !!_this.props.children,
      thereWereOnceChildren: !!_this.props.children,
      inlineComponentData: null
    });

    _defineProperty(_assertThisInitialized(_this), "onInitialMount", function () {
      if (_this.state.renderServerSideFallback) {
        _this.setState({
          renderServerSideFallback: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFullyMounted", function () {
      if (_this._adJustMounted) {
        // We just did this, so no point doing it again
        return;
      }

      var _this$props = _this.props,
          adId = _this$props.adId,
          adUrl = _this$props.adUrl,
          strategy = _this$props.strategy,
          afterId = _this$props.afterId;

      if (_this._adTriggered) {
        if (!_this.props.dangerouslyAllowMultipleLoads) {
          if (process.env.NODE_ENV !== 'production') {
            var key = "rendered-multiple-times-".concat(adId);

            if (!loggedWarnings[key]) {
              console.warn("<AdSpot> was rendered multiple times with the same adId (".concat(adId, "). The ad has not been reloaded, nor has the DOM been modified, however, the container _has_ been re-rendered. If you would like to also reload the ad, set the prop 'dangerouslyAllowMultipleLoads'.")); // eslint-disable-line no-console, max-len

              loggedWarnings[key] = true;
            }
          } // Haven't opted in to multiple renders of an ad, so bail out now.


          return;
        }

        if (process.env.NODE_ENV !== 'production') {
          var _key = "warning-dangerous-".concat(adId);

          if (!loggedWarnings[_key]) {
            console.info("You have opted in to rendering <AdSpot> multiple times with the same adId (".concat(adId, ") by setting the prop 'dangerouslyAllowMultipleLoads'. This is dangerous and can result in multiple ad impressions being counted, ultimately leading to incorrect billing and reporting to advertisers.")); // eslint-disable-line no-console, max-len

            loggedWarnings[_key] = true;
          }
        }
      }

      var callback = function callback(event) {
        // Only set state (and trigger a re-render) if there was previously no
        // ad visible. If there was already an ad visible, then there's no need
        // to re-render anything as we've already done all the transtion heavy
        // work, and don't need to re-render as the container div already exists
        // in the DOM for the ad to hook into.
        if (!_this.state.adVisible) {
          // Track that this re-render was triggered by us on purpose
          _this._adJustMounted = true;

          _this.setState({
            adVisible: true
          }, function () {
            // Now that the re-render has finished, unflag it
            _this._adJustMounted = false;
          });
        }

        _this.props.onMounted(event);
      };

      if (!_this.state.inlineComponentData) {
        _this.props.registerAdSpot({
          adId: adId,
          adUrl: adUrl,
          strategy: strategy,
          after: afterId
        }, adId ? callback : function (data) {
          _this.setState({
            inlineComponentData: _objectSpread(_objectSpread({}, data), {}, {
              dfpImpressionImageUrl: data && data.dfpImpUrl,
              thirdPartyImpressionImageUrl: data && data.thirdPartyImpUrl,
              headerStripColor: data && data.titleHex,
              headerStripBackgroundColor: data && data.topStripColour
            })
          }, callback);
        });
      }

      if (!_this._adTriggered) {
        _this._adTriggered = true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_adJustMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_adTriggered", false);

    if (Object.prototype.toString.call(_this.props.registerAdSpot) !== '[object Function]') {
      // eslint-disable-next-line max-len
      throw new Error('<AdSpot /> components must be a descendant of an <AdRoot /> or a component wrapped with the withAdRoot() HOC');
    }

    return _this;
  }

  _createClass(AdSpot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (process.env.NODE_ENV !== 'production') {
        if (adsLoaded[this.props.adId || this.props.adUrl]) {
          if (!adsLoaded[this.props.adId || this.props.adUrl].warned && !this.props.dangerouslyAllowMultipleLoads) {
            // eslint-disable-next-line max-len, no-console
            console.warn("More than one mount of <AdSpot> with adId (".concat(this.props.adId, ") has occured. The ad has been reloaded. This is dangerous and can result in multiple ad impressions being counted, ultimately leading to incorrect billing and reporting to advertisers. Disable this warning by adding the 'dangerouslyAllowMultipleLoads' prop."));
            adsLoaded[this.props.adId || this.props.adUrl].warned = true;
          }
        } else {
          adsLoaded[this.props.adId || this.props.adUrl] = {};
        }
      }
    } // The initial server side fallback is mounted first

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.noAds || !this.props.adId && !this.props.adUrl || this.props.adId && this.props.adUrl || this.props.adUrl && !this.props.inlineComponent) {
        return null;
      }

      var fallback = false; // Only inject the transition group if there were ever children

      if (this.state.thereWereOnceChildren) {
        var transitionProps = pickBy(this.props, function (_, key) {
          return key.indexOf('transition') === 0;
        });
        fallback = ___EmotionJSX(CSSTransitionGroup, _extends({
          key: "fallback-".concat(this.props.adId)
        }, transitionProps), this.state.adVisible ? false : this.props.children);
      }

      var wrapperRefFunc;
      var innerRefFunc;
      var innerAd = null;

      if (this.state.renderServerSideFallback) {
        // When server rendering, this wont be executed, but in the browser, it
        // will execute _after_ the mount, meaning we don't get any checksum
        // mismatches
        wrapperRefFunc = this.onInitialMount; // When server rendering (or first render for client), we don't yet want
        // to try loading any ads - instead, we want to let the dangerously set
        // HTML do its thing, then we'll come back to it on the next render

        innerRefFunc = function innerRefFunc() {};
      } else {
        // Now that we've rendered at least one full cycle client side, no more
        // refs needed for the wrapper
        wrapperRefFunc = function wrapperRefFunc() {}; // The dangerously set inner html has complete, so trigger the full mount
        // callback


        innerRefFunc = function innerRefFunc(element) {
          return element && _this2.onFullyMounted();
        };
      }

      if (this.props.adId) {
        // Because we have no control over what the ads do to the HTML, we give it
        // a container it can do whatever it wants with (dangerously set elements
        // are not included in React's diffing algorithm).
        innerAd = ___EmotionJSX("div", {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: {
            // eslint-disable-line react/no-danger
            __html: "<div id=\"".concat(this.props.adId, "\" class=\"adspot__inner\"></div>")
          },
          ref: innerRefFunc
        });
      } else {
        var InlineComponent = this.props.inlineComponent;
        innerAd = ___EmotionJSX("div", {
          ref: innerRefFunc,
          className: "adspot__inner"
        }, ___EmotionJSX(InlineComponent, this.state.inlineComponentData));
      }

      return ___EmotionJSX("div", {
        ref: wrapperRefFunc,
        css: styles.adspotWrapper,
        className: classnames('adspot__wrapper', this.props.className)
      }, fallback, innerAd);
    }
  }]);

  return AdSpot;
}(React.Component);

AdSpot.propTypes = _objectSpread({
  adId: customPropType.exactlyOneOfType({
    types: [PropTypes.string.isRequired, customPropType.alternate('adUrl', PropTypes.any.isRequired)],
    noMatchMessage: 'At least one of `adId` or `adUrl` has to be set',
    tooManyMessage: 'Can only set one of `adId` and `adUrl` at a time'
  }),
  adUrl: customPropType.exactlyOneOfType({
    types: [customPropType.every([PropTypes.string.isRequired, customPropType.alternate('inlineComponent', PropTypes.any.isRequired)], 'When `adUrl` is set, `inlineComponent` must also be set'), customPropType.alternate('adId', PropTypes.any.isRequired)],
    noMatchMessage: 'At least one of `adUrl` or `adId` has to be set',
    tooManyMessage: 'Can only set one of `adUrl` and `adId` at a time'
  }),
  inlineComponent: customPropType.exactlyOneOfType({
    types: [customPropType.every([PropTypes.func.isRequired, customPropType.alternate('adUrl', PropTypes.any.isRequired)], 'When `inlineComponent` is set, `adUrl` must also be set'), customPropType.alternate('adId', PropTypes.any.isRequired)],
    noMatchMessage: 'At least one of `inlineComponent` or `adId` has to be set',
    tooManymessage: 'Can only set one of `inlineComponent` and `adId` at a time'
  }),
  children: PropTypes.node,
  onMounted: PropTypes.func,
  className: PropTypes.string,
  dangerouslyAllowMultipleLoads: PropTypes.bool,
  // NOTE: Why don't we do a DOMContentLoaded strategy? Loading an ad is
  // already restricted to the client, which means this JS has to be executed,
  // which means we're already at the bottom of the DOM, which means
  // DOMContentLoaded is about to, or has already fired. So it's almost
  // equivalent to doing requestAnimationFrame.
  strategy: PropTypes.oneOf(['immediate', 'requestAnimationFrame', 'window.onload']),
  afterId: PropTypes.string
}, CSSTransitionGroup.propTypes);
AdSpot.defaultProps = {
  adId: undefined,
  adUrl: undefined,
  children: null,
  inlineComponent: null,
  className: '',
  onMounted: function onMounted() {},
  dangerouslyAllowMultipleLoads: false,
  strategy: 'immediate',
  afterId: null,
  transitionName: 'adspot-transition',
  transitionEnter: false,
  transitionLeave: false,
  transitionEnterTimeout: 1000,
  transitionLeaveTimeout: 1000
};
export default withAdControl(AdSpot);